import { render, staticRenderFns } from "./LetterTemplates.vue?vue&type=template&id=649ce0d8&scoped=true"
import script from "./LetterTemplates.vue?vue&type=script&lang=js"
export * from "./LetterTemplates.vue?vue&type=script&lang=js"
import style0 from "./LetterTemplates.vue?vue&type=style&index=0&id=649ce0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649ce0d8",
  null
  
)

export default component.exports